import { createTheme } from '@mui/material/styles';
import { themeVariables } from './themeVariables';

export const theme = createTheme({
  palette: {
    primary: {
      main: themeVariables.colors.primary,
      light: themeVariables.colors.primaryLight,
      dark: themeVariables.colors.primaryDarker
    },
    secondary: {
      main: '#5540ff'
    },
    text: {
      primary: themeVariables.textColors.primary,
      secondary: '#807175',
      disabled: themeVariables.textColors.gray,
      hint: '#ef7e51'
    }
  },
  typography: {
    fontFamily:
      'Kanit, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
  },
  brand: {
    primary: {
      light: '#98c0fd',
      400: '#2985e2',
      main: '#0968c3',
      dark: '#064785'
    },
    secondary: {
      main: '#737373'
    }
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '1rem',
          border: 'none',
          '&::before': {
            border: 'none'
          },
          '&::after': {
            border: 'none'
          },
          '&:hover::before': {
            border: 'none!important;'
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '1rem',
          '& .MuiInputBase-input': {
            border: 'none',
            borderRadius: '1rem'
          },
          '& .MuiInputBase-root': {
            borderRadius: '1rem',
            '&:hover::before': {
              border: 'none!important;'
            }
          },
          '& .MuiFilledInput-underline:before': {
            border: 'none'
          },
          '& .MuiFilledInput-underline:after': {
            borderBottom: 'none'
          },
          '& .MuiInputBase-root.Mui-disabled:before': {
            borderBottom: 'none'
          },
          '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: themeVariables.colors.backgroundGray
          }
        }
      }
    }
  }
});
